// extracted by mini-css-extract-plugin
export default {"icon":"fullscreenControlButton-module__icon__x2XNJ","buttonContent":"fullscreenControlButton-module__buttonContent__xpXoI"};